const TOKEN_KEY = "authToken";
const USER_KEY = "userData";

export const saveAuthData = (token, userData, rememberMe = true) => {
  const storage = rememberMe ? localStorage : sessionStorage;
  if (token) storage.setItem(TOKEN_KEY, token);
  if (userData) storage.setItem(USER_KEY, JSON.stringify(userData));
};

export const getToken = () => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) return token;
  return sessionStorage.getItem(TOKEN_KEY);
};

export const getUserData = () => {
  const data =
    localStorage.getItem(USER_KEY) || sessionStorage.getItem(USER_KEY);
  return data ? JSON.parse(data) : null;
};

export const clearAuthData = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  sessionStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(USER_KEY);
};
